<template>
  <div class="container-fluid px-md-4">
    <div class="panel-heading my-2">
      <h2 class="text-left">User Claims Management</h2>
    </div>
    <form class="needs-validation pt-1 my-2" @submit.prevent="getUserClaims">
      <div class="form-group row justify-content-between m-0">
        <div class="mx-3 my-1">
          <label class="mr-3 col-form-label">Tenant</label>
          <dropdownlist
            class="m-2"
            ref="tenantDropdown"
            :data-items="tenants"
            :text-field="'name'"
            :data-item-key="'id'"
            :default-value="tenants[0]"
            @change="onSelectTenant"
          >
          </dropdownlist>

          <label class="col-form-label mr-4"> User</label>
          <dropdownlist
            class="m-2"
            ref="userDropdown"
            :data-items="users"
            :text-field="'userName'"
            :data-item-key="'id'"
            @change="onChange"
          >
          </dropdownlist>

          <button
            type="submit"
            value="Search"
            class="k-button k-secondary mr-4"
          >
            <i class="fa fa-search" aria-hidden="true"></i> Search
          </button>
        </div>
        <div class="my-auto mx-auto mx-sm-2">
          <button
            title="Add new"
            class="k-button k-secondary"
            type="button"
            @click="insert"
          >
            <i class="fa fa-plus mr-2" aria-hidden="true"></i>

            Add new
          </button>
        </div>
      </div>
    </form>
    <div class="example-wrapper" v-if="userClaims">
      <Grid
        ref="grid"
        :style="{ height: '55vh' }"
        :pageable="true"
        :sortable="true"
        :resizable="true"
        :filterable="true"
        :filter="filter"
        :groupable="false"
        :group="group"
        :sort="sort"
        :skip="skip"
        :data-items="gridData"
        :columns="columns"
        :take="take"
        @datastatechange="dataStateChange"
        @expandchange="expandChange"
      >
        <template v-slot:myTemplate="{ props }">
          <custom :data-item="props.dataItem" @edit="edit" @remove="remove" />
        </template>
        <grid-norecords> There is no data available custom </grid-norecords>
      </Grid>
      <dialog-container
        v-if="userClaimInEdit"
        :dialog-title="dialogTitle"
        :data-item="userClaimInEdit"
        @save="save"
        @cancel="cancel"
      >
      </dialog-container>
    </div>
  </div>
</template>
<script>
import { Grid, GridToolbar, GridNoRecords } from "@progress/kendo-vue-grid";
import { sampleUserClaims } from "./data";
import { process } from "@progress/kendo-data-query";
import DialogContainer from "./DialogContainer";
import CommandCell from "./CommandCell";
import axios from "axios";
import { DropDownList } from "@progress/kendo-vue-dropdowns";
import { oidcSettings } from "../../services/store";

export default {
  components: {
    Grid: Grid,
    "grid-toolbar": GridToolbar,
    "grid-norecords": GridNoRecords,
    "dialog-container": DialogContainer,
    custom: CommandCell,
    dropdownlist: DropDownList,
  },
  props: {
    identity: {
      type: Object,
      default: null,
    },
  },
  data: function () {
    return {
      base_url: undefined,

      sort: [{ field: "name", dir: "asc" }],
      userClaims: undefined, //sampleUserClaims,
      identityPools: [],
      tenants: [{ id: "", name: "No Tenant" }],
      selectedIdentity: undefined,
      selectedTenant: undefined,
      tempIdentity: this.identity,
      tempTenant: undefined,
      selectedUser: undefined,
      tempUser: undefined,
      users: [],
      events: [],
      filter: {
        logic: "and",
        filters: [],
      },
      gridData: [],
      skip: 0,
      take: 10,
      group: [],
      userClaimInEdit: undefined,
      columns: [
        { field: "claimType", title: "Claim Type" },
        {
          field: "claimValue",
          editable: false,
          title: "Claim Value",
        },

        { cell: "myTemplate", width: "150px", filterable: false },
      ],
    };
  },
  computed: {
    dialogTitle() {
      return `${
        this.userClaimInEdit.claimType === undefined ? "Add" : "Edit"
      } User Claim`;
    },
  },
  beforeMount: function () {
    this.base_url = oidcSettings.authority + "/api/IdentityManagement/";
    if (this.tempIdentity != null) {
      this.getTenants();
    }
  },
  watch: {
    identity: function () {
      this.tempIdentity = this.identity;
      this.tempTenant = undefined;
      this.$refs.tenantDropdown.currentValue = this.tenants[0];
      this.tempUser = undefined;
      this.$refs.userDropdown.currentValue = null;
      this.users = [];
      this.getTenants();
    },
  },
  methods: {
    dataStateChange: function (event) {
      this.createAppState(event.data);
      console.log(event);
    },

    expandChange: function (event) {
      Vue.set(event.dataItem, event.target.$props.expandField, event.value);
    },
    createAppState: function (dataState) {
      this.group = dataState.group;
      this.take = dataState.take;
      this.skip = dataState.skip;
      this.filter = dataState.filter;
      this.sort = dataState.sort;
      console.log(dataState);
      this.getData();
    },
    getData: function () {
      console.log("aaa", this.filter);
      this.gridData = process(this.userClaims, {
        take: this.take,
        skip: this.skip,
        group: this.group,
        sort: this.sort,
        filter: this.filter,
      });
    },
    async getTenants() {
      try {
        const client_id = oidcSettings.client_id;

        const response = await axios.get(
          this.base_url + "Tenant/GetTenants/" + this.tempIdentity.id
        );
        this.tenants = response.data.result;
        this.tenants.unshift({ id: "", name: "No Tenant" });
        this.tempTenant = this.tenants[0];
        this.getUsers();
      } catch (err) {
        console.log(err);
      }
    },
    async getUsers() {
      try {
        const client_id = oidcSettings.client_id;

        const response = await axios.get(
          this.base_url +
            "User/GetUsers/" +
            this.tempIdentity.id +
            "/" +
            this.tempTenant.id
        );
        this.users = response.data.result;
      } catch (err) {
        console.log(err);
      }
    },
    onSelectIdentity(event) {
      console.log("change", event.target.value);
      this.tempIdentity = event.target.value;
      this.tempTenant = undefined;
      this.$refs.tenantDropdown.currentValue = null;
      this.getTenants();
    },
    onSelectTenant(event) {
      console.log("change", event.target.value);
      this.tempTenant = event.target.value;
      this.tempUser = undefined;
      this.$refs.userDropdown.currentValue = null;

      this.getUsers();
    },
    async getUserClaims() {
      if (this.tempUser == null) {
        return;
      } else {
        this.selectedIdentity = this.tempIdentity;
        this.selectedTenant = this.tempTenant;
        this.selectedUser = this.tempUser;
        try {
          const response = await axios.get(
            this.base_url +
              "UserClaim/GetUserClaims/" +
              this.selectedUser.id +
              "/" +
              this.selectedIdentity.id +
              "/" +
              this.selectedTenant.id
          );
          this.userClaims = response.data.result;
          this.getData();
        } catch (err) {
          console.log(err);
        }
      }
    },
    edit(dataItem) {
      this.userClaimInEdit = this.cloneProduct(dataItem);
    },
    async remove(dataItem) {
      try {
        const response = await axios.delete(
          this.base_url +
            "UserClaim/DeleteUserClaim/" +
            this.selectedUser.id +
            "/" +
            dataItem.claimType +
            "/" +
            this.selectedIdentity.id +
            "/" +
            this.selectedTenant.id
        );
        console.log(response.data.message);
        this.userClaims = this.userClaims.filter(
          (p) => p.claimType !== dataItem.claimType
        );
        this.getData();
      } catch (err) {
        console.log(err);
      }
    },
    onChange(event) {
      console.log("change", event.target.value);
      //this should be moved to on submit
      this.tempUser = event.target.value;
    },
    async addUserClaim(dataItem) {
      let data = {
        value: dataItem.claimValue,
        type: dataItem.claimType,
      };
      try {
        const response = await axios.post(
          this.base_url +
            "UserClaim/AddUserClaim/" +
            this.selectedUser.id +
            "/" +
            this.selectedIdentity.id +
            "/" +
            this.selectedTenant.id,
          [data]
        );
        this.status = response.data.status;
        this.responseMsg = response.data.message;
        console.log(this.responseMsg);
        this.showMsg = true;
        this.dataItem = {};
        this.userClaims.push(data);
        this.getUserClaims();
      } catch (err) {
        console.log("Ooops!" + err);
      }
    },
    async editUserClaim(dataItem) {
      let data = {
        value: dataItem.claimValue,
        type: dataItem.claimType,
      };
      try {
        const response = await axios.put(
          this.base_url +
            "UserClaim/UpdateUserClaim/" +
            this.selectedUser.id +
            "/" +
            this.selectedIdentity.id +
            "/" +
            this.selectedTenant.id,
          data
        );
        this.status = response.data.status;
        this.responseMsg = response.data.message;
        console.log(this.responseMsg);
        this.showMsg = true;
        this.dataItem = {};
        const index = this.userClaims.findIndex(
          (p) => p.claimType === dataItem.claimType
        );
        this.userClaims.splice(index, 1, dataItem);
      } catch (err) {
        console.log("Ooops!" + err);
      }
    },
    save() {
      const dataItem = this.userClaimInEdit;
      const userClaims = this.userClaims.slice();
      const isNewClaim = this.userClaims.find(
        (userClaim) => userClaim.claimType == dataItem.claimType
      );
      if (!isNewClaim) {
        this.addUserClaim(dataItem);
      } else {
        this.editUserClaim(dataItem);
      }
      this.userClaimInEdit = undefined;
    },
    cancel() {
      this.userClaimInEdit = undefined;
    },
    insert() {
      this.userClaimInEdit = {};
    },
    cloneProduct(product) {
      return Object.assign({}, product);
    },
  },
};
</script>
<style >
.error {
  color: brown;
  margin: auto;
  text-align: left;
  padding: 5px;
}
.needs-validation {
  background: white;
}
</style>